// RegisterForm.js
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function RegisterForm() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { register } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    if (formData.password !== formData.confirmPassword) {
      setError('Die Passwörter stimmen nicht überein');
      return false;
    }
    if (formData.password.length < 6) {
      setError('Das Passwort muss mindestens 6 Zeichen lang sein');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    
    setError('');
    setIsLoading(true);

    try {
      await register(formData.email, formData.password);
      navigate('/portfolio');
    } catch (err) {
      switch (err.code) {
        case 'auth/email-already-in-use':
          setError('Ein Konto mit dieser E-Mail existiert bereits');
          break;
        case 'auth/invalid-email':
          setError('Ungültige E-Mail-Adresse');
          break;
        case 'auth/operation-not-allowed':
          setError('E-Mail/Passwort-Registrierung ist nicht aktiviert');
          break;
        case 'auth/weak-password':
          setError('Das Passwort ist zu schwach');
          break;
        default:
          setError(err.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="login-form">
      {error && (
        <div className="error-message">
          <i className="fas fa-exclamation-circle"></i>
          {error}
        </div>
      )}

      <div className="form-group">
        <label>E-Mail-Adresse</label>
        <div className="input-group">
          <span className="input-group-text">
            <i className="fas fa-envelope"></i>
          </span>
          <input
            type="email"
            name="email"
            className="form-control"
            value={formData.email}
            onChange={handleChange}
            placeholder="Gib deine E-Mail ein"
            required
          />
        </div>
      </div>

      <div className="form-group">
        <label>Passwort</label>
        <div className="input-group">
          <span className="input-group-text">
            <i className="fas fa-lock"></i>
          </span>
          <input
            type="password"
            name="password"
            className="form-control"
            value={formData.password}
            onChange={handleChange}
            placeholder="Erstelle ein Passwort"
            required
          />
        </div>
      </div>

      <div className="form-group">
        <label>Passwort bestätigen</label>
        <div className="input-group">
          <span className="input-group-text">
            <i className="fas fa-lock"></i>
          </span>
          <input
            type="password"
            name="confirmPassword"
            className="form-control"
            value={formData.confirmPassword}
            onChange={handleChange}
            placeholder="Bestätige dein Passwort"
            required
          />
        </div>
      </div>

      <button 
        type="submit" 
        className={`login-button ${isLoading ? 'loading' : ''}`}
        disabled={isLoading}
      >
        {isLoading ? (
          <span className="loading-spinner">
            <i className="fas fa-spinner fa-spin"></i>
          </span>
        ) : (
          'Konto erstellen'
        )}
      </button>

      <div className="register-prompt">
        Du hast bereits ein Konto? <a href="/login">Hier einloggen</a>
      </div>
    </form>
  );
}

export default RegisterForm;